export default "__VITE_ASSET__BgCBSpVt__"